import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Col, Checkbox, Button, Typography, theme, Flex } from '@app/ui';
import './selectingMetrics.scss';
import useOnClickOutside from '../components/hooks/useOnClickOutside';

const SelectingMetrics = ({
    insightsColumns,
    columns,
    setColumns,
    onClose,
}) => {
    const { t } = useTranslation('measurement');
    const [selectedMetrics, setSelectedMetrics] = useState({});
    const ref = useRef(null);

    useOnClickOutside(ref, onClose);

    useEffect(() => {
        if (columns) setSelectedMetrics(columns);
    }, [columns]);

    const toggleMetric = name => () => {
        setSelectedMetrics(prev => ({
            ...prev,
            [name]: !prev[name],
        }));
    };

    const apply = () => {
        setColumns(selectedMetrics);
        onClose();
    };

    const {
        token: { colorPrimary },
    } = theme.useToken();

    const disableApply =
        Object.keys(selectedMetrics).length &&
        !Object.values(selectedMetrics).includes(true);

    return (
        <div className="tooltip" style={{ padding: 16, top: -290 }} ref={ref}>
            <Typography.Title level={5} style={{ marginBottom: 8 }}>
                <i
                    className="fa-light fa-gear -m-r-2"
                    style={{
                        color: colorPrimary,
                    }}
                />
                {t('dataExplorer.selectMetrics.title')}
            </Typography.Title>
            <Row gutter={[8, 8]}>
                {insightsColumns.map(metric => {
                    const id = metric.dbname;
                    const isSelected = !!selectedMetrics[id];
                    const translatedName = t(`dataExplorer.columns.${id}`, {
                        defaultValue: metric.name,
                    });

                    return (
                        <Col span={12} key={id}>
                            <Checkbox
                                checked={isSelected}
                                onChange={toggleMetric(id)}
                            >
                                {translatedName}
                            </Checkbox>
                        </Col>
                    );
                })}
            </Row>

            <div style={{ textAlign: 'right', marginTop: 16 }}>
                <Flex gap={8} justify="flex-end">
                    <Button
                        type="primary"
                        color="default"
                        variant="solid"
                        size="small"
                        onClick={onClose}
                    >
                        {t('dataExplorer.selectMetrics.cancel')}
                    </Button>
                    <Button
                        type="primary"
                        size="small"
                        onClick={apply}
                        disabled={disableApply}
                    >
                        {t('dataExplorer.selectMetrics.apply')}
                    </Button>
                </Flex>
            </div>

            {disableApply && (
                <Typography.Text type="danger" style={{ fontSize: 12 }}>
                    {t('dataExplorer.selectMetrics.selectAtLeastOne')}
                </Typography.Text>
            )}
        </div>
    );
};

SelectingMetrics.propTypes = {
    columns: PropTypes.object,
    setColumns: PropTypes.func,
    insightsColumns: PropTypes.array,
    onClose: PropTypes.func,
};

export default SelectingMetrics;
